module.exports = __webpack_public_path__ + "fi-utz-cocoa-2eaf8b1fdd2857cc7ce65b0bd146e07e.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/fi-utz-cocoa.png
// module id = 87
// module chunks = 0